import { Map, fromJS } from 'immutable';

import {
  DATA_FETCHED_ERROR,
  DATA_FETCH_REQUEST,
  DATA_END_FETCH_REQUEST,
  DATA_CONFIG,
  DATA_SEARCH
} from '../actions/config.actions';

const initialState = new Map();

export default function reducer(state=initialState, action) {
  let nextState;
  switch (action.type) {
    case DATA_FETCHED_ERROR:
      console.log('FETCH ERROR', action.err);
      nextState = state;
      break;
    case DATA_FETCH_REQUEST:
      nextState = state.setIn(['fetching', action.id], true);
      break;
    case DATA_END_FETCH_REQUEST:
      nextState = state.setIn(['fetching', action.id], false);
      break;
    case DATA_CONFIG:
      nextState = state.set(DATA_CONFIG, fromJS(action.data.config));
      break;
    case DATA_SEARCH:
      nextState = state.set(DATA_SEARCH, action.data);
      break;

    default:
      nextState = state;
      break;
  }

  return nextState;
};
